import React from 'react';
import createResolver from 'sections/SectionResolver';
import Page from 'components/Page';

import data from 'data/notFound';
import NotFoundSection from 'sections/NotFound';
import RedBlockSection from 'sections/RedBlockSection';

const COMPONENTS = {
  NotFoundSection,
  RedBlockSection,
};

const Section = createResolver(COMPONENTS);

export default () => (
  <Page background="grey" meta={data.meta}>
    {data.sections.map((props, key) => (
      <Section key={key} {...props} />
    ))}
  </Page>
);
